import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  DoughnutController,
  Filler,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js';

let registered = false;

/**
 * react-chartjs-2 v5 does not auto-register anything, so this is required
 * rather than optional. Registering explicitly instead of importing
 * `chart.js/auto` keeps every controller we do not use out of the bundle.
 *
 * TimeScale is deliberately absent: `chartjs-adapter-date-fns` is not installed,
 * so registering it would throw at runtime. Every time axis is a CategoryScale
 * over labels the server already rendered in the reporting timezone — which
 * also means a bucket boundary is computed once, server-side, rather than being
 * re-derived in whatever timezone the viewer happens to be in.
 */
export function registerCharts() {
  if (registered) return;
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarController,
    BarElement,
    LineController,
    LineElement,
    PointElement,
    DoughnutController,
    ArcElement,
    Tooltip,
    Legend,
    Filler,
  );
  ChartJS.defaults.font.family = 'Inter, system-ui, sans-serif';
  ChartJS.defaults.font.size = 12;
  ChartJS.defaults.animation.duration = 220;
  registered = true;
}

export const PROVIDER_COLORS = {
  openai: '#2C59F8',
  elevenlabs: '#8B5CF6',
  heygen: '#F45B2B',
  liveavatar: '#6DD24A',
};

export const SERIES_COLORS = [
  '#2C59F8', '#6DD24A', '#F45B2B', '#8B5CF6',
  '#0EA5E9', '#e7483d', '#F59E0B', '#14B8A6', '#717C9E',
];

export const colorForKey = (key, index) =>
  PROVIDER_COLORS[key] ?? SERIES_COLORS[index % SERIES_COLORS.length];
